export default __webpack_public_path__ + "static/media/labeldat3.e9def374.png";